import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@common/encoding';
import { Address } from './addresses/Address.js';
export class OrganizationSimple extends AutoEncoder {
    id;
    uri = '';
    /**
     * Name of the organization you are creating
     */
    name;
    address;
}
__decorate([
    field({ decoder: StringDecoder })
], OrganizationSimple.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 344 })
], OrganizationSimple.prototype, "uri", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OrganizationSimple.prototype, "name", void 0);
__decorate([
    field({ decoder: Address })
], OrganizationSimple.prototype, "address", void 0);
//# sourceMappingURL=OrganizationSimple.js.map